import './styles/index.scss';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';

import App from './App';
import './i18n';
import { registerServiceWorker } from './shared/services/pwa-install';
import { store } from './store';

// Регистрируем SW (нужен для установимости PWA) и сразу начинаем ловить beforeinstallprompt.
registerServiceWorker();

const rootEl = document.getElementById('root');
if (rootEl) {
  const helmetContext = {};

  const root = createRoot(rootEl);
  // Здесь — только нейтральные для всех областей провайдеры. Тема и заголовки оболочки —
  // в AppProvider, у админки — свои в AdminProvider.
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <HelmetProvider context={helmetContext}>
          <App />
        </HelmetProvider>
      </Provider>
    </React.StrictMode>
  );
}
